module.exports = __webpack_public_path__ + "assets/img/4_317.cd06b5c1.jpg";